module.exports = __webpack_public_path__ + "static/media/paytm_logo_simple.37c82f2d.svg";